import React, { useState, } from 'react'

import { Carousel as CarouselComp } from 'react-responsive-carousel'
import styled from 'styled-components'
import 'react-responsive-carousel/lib/styles/carousel.min.css'

// import { useEventListener } from '../../../_helpers'
import {
    devices,
    colors,
    CarouselNext,
    CarouselPrev,
    Title,
    ThumbnailsIcon,
} from '../../Common'


export const SimpleCarousel = ({ slides, title, close, activeImage, mobile }) => {
    const [activeSlide, setActiveSlide] = useState(activeImage)
    const [caption, setCaption] = useState(slides[activeImage].author)

    const handleChange = id => {
        setActiveSlide(id)
        setCaption(slides[id].author)
    }

    const next = () => setActiveSlide(activeSlide + 1)
    const prev = () => setActiveSlide(activeSlide - 1)

    return (
        <CarouselContainer>
            <CarouselFlex>
                <CarouselPrev onClick={prev} role='button' aria-label='Previous slide' />
                <div style={{ width: `${mobile ? '100%' : '90%'}` }}>
                    <Title fontSize={mobile ? 14 : 16}>{title}</Title>
                    <StyledCarousel
                        showStatus={false}
                        showArrows={false}
                        showThumbs={false}
                        showIndicators={false}
                        infiniteLoop={slides.length > 1}
                        stopOnHover={false}
                        interval={5000}
                        transitionTime={800}
                        autoPlay={false}
                        selectedItem={activeSlide}
                        onChange={handleChange}
                    >

                        {slides.map(img =>
                            <ImageCard
                                key={img.image}
                                background={img.image}
                                alt={img.alt_text}
                                orientation={img.orientation}
                            />
                        )}
                    </StyledCarousel>
                    <ThumbnailButton onClick={close}>
                        <ThumbnailsIcon />
                        Show Thumbnails
                    </ThumbnailButton>
                    <Caption>{caption || ' '}</Caption>
                </div>
                <CarouselNext onClick={next} role='button' aria-label='Next slide' />
            </CarouselFlex>
        </CarouselContainer>
    )
}

const ThumbnailButton = styled.div`
    margin-top: 10px;
    text-transform: uppercase;
    display: flex;
    justify-content: space-between;
    align-items: center;
    color: ${colors.white};
    font-weight: 900;
    font-size: 12px;
    position: absolute;
    cursor: pointer;
`

const CarouselContainer = styled.div`
    /* position: relative; */
    padding-top: 50px;
    padding-bottom: 50px;

    @media ${devices.small} {
        align-self: flex-start;
        padding-left: 20px;
        padding-right: 20px;
    }

    @media (max-width: 1450px) {
        padding-left: 50px;
        padding-right: 50px;
    }
`

const StyledCarousel = styled(CarouselComp)`

    @media ${devices.small} {
    }

    .slide {
        background: transparent;
    }

    && {
        .control-dots {
            display: none;
        }
    }
`

export const VideoThumbnail = styled.div`
    height: ${({ height }) => height}px;
    background: url(${({ image }) => image});
    background-position: center;
    background-size: cover;
    cursor: pointer;

    @media ${devices.small} {
        height: 210px;
    }
`

export const VideoPlayButton = styled.div`
    height: 55px;
    width: 47px;
    background: url(/static/images/sprite.svg) -1px -570px;
    cursor: pointer;
`

const ImageCard = styled.div`
    width: ${props => props.orientation === 'landscape' ? '100%' : '40%'};
    height: 0;
    padding-bottom: 56.25%;
    background: url(${props => props.background}) no-repeat center/cover;
    margin-bottom: 0;
    background-position: top;
    border: 7px solid white;
    position: relative;
    margin: 0 auto;
    @media ${devices.small} {
        border-width: 3px;
    }
`

const CarouselFlex = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    position: relative;
`

const Caption = styled.div`
    font-size: 14px;
    text-align: end;
    margin-top: 10px;
    color: ${colors.white};
    text-transform: uppercase;
`
